import { Route, Switch, useLocation } from "react-router"
import { ThemeProvider } from "styled-components"
import { lightTheme } from "./components/Themes"
import GlobalStyle from "./globalStyles"


//Components
import Main from './components/Main';
import AboutPage from './components/AboutPage';
import BlogPage from './components/BlogPage';
import WorkPage from './components/WorkPage';
import MySkillsPage from './components/MySkillsPage';
import BlogArticle from "./components/BlogArticle";
import { AnimatePresence } from "framer-motion";


function App() {

  const location = useLocation();
  return <>


    <GlobalStyle />

    <ThemeProvider theme={lightTheme}>

      {/* <SoundBar /> */}

      {/* For framer-motion animation on page change! */}
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route exact path="/" component={Main} />
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/blog" component={BlogPage} />
          <Route exact path="/work" component={WorkPage} />
          <Route exact path="/skills" component={MySkillsPage} />
          <Route exact path="/article" render={() => {
            return <BlogArticle id="0" />
          }} />
          <Route path="/article/:type/:id" render={({ match }) => {
            return <BlogArticle id={match.params.id} type={match.params.type}/>
          }} />
        </Switch>
      </AnimatePresence>


    </ThemeProvider>



  </>

}

export default App

